import { Home, Search, Briefcase, User, MessageCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface BottomNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const BottomNavigation = ({ activeTab, onTabChange }: BottomNavigationProps) => {
  const tabs = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'marketplace', label: 'WOM Plaza', icon: Search },
    { id: 'berichten', label: 'Berichten', icon: MessageCircle },
    { id: 'vacatures', label: 'Vacatures', icon: Briefcase },
    { id: 'profiel', label: 'Profiel', icon: User },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 px-4 py-3 safe-area-pb">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {tabs.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={cn(
              "flex flex-col items-center justify-center p-3 rounded-lg transition-all duration-200",
              "hover:bg-stone-100 active:scale-95",
              activeTab === id
                ? "text-stone-800 bg-stone-100"
                : "text-stone-600 hover:text-stone-700"
            )}
          >
            <Icon className="h-5 w-5 mb-1" />
            <span className="text-xs font-medium">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;